import { clinicInfo } from "../../mocks/home-data";
import FadeIn from "../../components/base/FadeIn";
import PageHero from "../../components/feature/PageHero";

export default function About() {
  return (
    <main>
      <PageHero
        badge="Hakkımızda"
        title={
          <>
            <span className="font-serif italic text-primary-300">Ankara Keçiören'in</span>
            <br />
            Güvenilir Kliniği
          </>
        }
        description="Ankara Keçiören'de kuş ve egzotik hayvan bakımı ile hizmet veren modern veteriner kliniği. Tüylü ve pullu dostlarınızın sağlığı için özenli ekibimizle yanınızdayız."
        backgroundImage="/assets/images/about-hero-bg.jpg"
      />

      {/* Story Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
              <FadeIn>
                <div>
                  <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-6 leading-tight">
                    Neden{" "}
                    <span className="font-serif italic text-primary-700">Biz?</span>
                  </h2>
                  <div className="space-y-5 text-gray-600 leading-relaxed text-lg">
                    <p>
                      İhsan Özer Veteriner Kliniği olarak, Ankara Keçiören'de 2020'den beri
                      pet hekimliği ve egzotik hayvan bakımı alanlarında hizmet veriyoruz.
                      Özellikle kuş ve egzotik hayvanlar konusundaki deneyimimizle bölgede
                      öne çıkan bir klinik olmanın gururunu yaşıyoruz.
                    </p>
                    <p>
                      Modern teknolojik ekipmanlarımız ve sürekli kendini geliştiren ekibimizle,
                      dostlarınıza en iyi bakımı sunmayı ilke edindik. Ağız ve diş cerrahisi,
                      ortopedi operasyonları ve egzotik hayvan cerrahisi gibi özel alanlarda
                      kapsamlı hizmet veriyoruz.
                    </p>
                    <p>
                      Her canlı dostumuzun kendine özel ihtiyaçları olduğunun bilincindeyiz.
                      Bu nedenle her hastamıza bireysel yaklaşım sergileyerek, en doğru teşhis
                      ve en etkili tedavi yöntemlerini uyguluyoruz.
                    </p>
                  </div>

                  <div className="mt-8 flex flex-wrap gap-4">
                    <a
                      href={`tel:${clinicInfo.phoneRaw}`}
                      className="inline-flex items-center gap-2 px-6 py-3 bg-primary-600 hover:bg-primary-700 text-white font-semibold rounded-xl transition-all duration-300 whitespace-nowrap shadow-md hover:shadow-lg"
                    >
                      <i className="ri-phone-line w-5 h-5 flex items-center justify-center" />
                      {clinicInfo.phone}
                    </a>
                    <a
                      href="https://wa.me/905396960677"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 px-6 py-3 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-xl transition-all duration-300 whitespace-nowrap shadow-md hover:shadow-lg"
                    >
                      <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center" />
                      WhatsApp
                    </a>
                  </div>
                </div>
              </FadeIn>

              <FadeIn delay={0.2} direction="left">
                <div className="relative rounded-3xl overflow-hidden w-full h-[480px]">
                  <img
                    src="/assets/images/about-main-v3.jpg"
                    alt="Klinik ve Veteriner"
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary-950/40 via-transparent to-transparent" />
                  <div className="absolute bottom-6 left-6 right-6">
                    <div className="flex gap-3 flex-wrap">
                      <div className="bg-white/90 backdrop-blur-sm rounded-xl px-4 py-3 flex items-center gap-2">
                        <i className="ri-award-line text-primary-600 w-5 h-5 flex items-center justify-center" />
                        <span className="text-sm font-semibold text-gray-800">2020'den Beri Hizmet</span>
                      </div>
                      <div className="bg-white/90 backdrop-blur-sm rounded-xl px-4 py-3 flex items-center gap-2">
                        <i className="ri-heart-line text-primary-600 w-5 h-5 flex items-center justify-center" />
                        <span className="text-sm font-semibold text-gray-800">5000+ Mutlu Hasta</span>
                      </div>
                    </div>
                  </div>
                </div>
              </FadeIn>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-16 md:py-20 bg-primary-950">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
              {[
                { number: "2020", label: "Kuruluş Yılı", desc: "Yıllardır hizmetinizdeyiz" },
                { number: "5000+", label: "Mutlu Hasta", desc: "Tedavi edilen dost" },
                { number: "50+", label: "Egzotik Tür", desc: "Uzmanlık alanımız" },
                { number: "Acil", label: "Telefon Desteği", desc: "Gerektiğinde arayın" },
              ].map((stat, index) => (
                <FadeIn key={stat.label} delay={index * 0.1}>
                  <div className="text-center p-6">
                    <p className="text-4xl md:text-5xl font-bold text-primary-300 mb-2">{stat.number}</p>
                    <p className="text-sm font-semibold text-white mb-1">{stat.label}</p>
                    <p className="text-xs text-primary-400">{stat.desc}</p>
                  </div>
                </FadeIn>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 md:py-24 bg-white">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-7xl mx-auto">
            <FadeIn>
              <div className="text-center mb-16">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                  Değerlerimiz
                </h2>
                <p className="text-gray-600 max-w-2xl mx-auto text-lg">
                  Her zaman dostlarınızın sağlığını ve konforunu ön planda tutuyoruz
                </p>
              </div>
            </FadeIn>
            <div className="grid md:grid-cols-3 gap-6 md:gap-8">
              {[
                {
                  icon: "ri-heart-line",
                  title: "Sevgiyle Bakım",
                  desc: "Her hastamıza kendi evcil hayvanımız gibi şefkatle ve özenle yaklaşıyoruz. Onların acısını hissediyor, mutluluğunu paylaşıyoruz.",
                },
                {
                  icon: "ri-shield-check-line",
                  title: "Güvenilir Hizmet",
                  desc: "Modern ekipmanlar ve kanıtlanmış tedavi yöntemleriyle güvenli veteriner hizmeti sunuyoruz. Her işlemde en yüksek standartları uyguluyoruz.",
                },
                {
                  icon: "ri-lightbulb-line",
                  title: "Sürekli Gelişim",
                  desc: "Veteriner tıbbındaki son gelişmeleri takip ederek en iyi bakımı sunuyoruz. Düzenli eğitimlerle kendimizi sürekli güncelliyoruz.",
                },
              ].map((value, index) => (
                <FadeIn key={value.title} delay={index * 0.1}>
                  <div className="bg-cream-50 rounded-2xl p-8 text-center transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
                    <div className="w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-5">
                      <i className={`${value.icon} text-3xl text-primary-700 w-8 h-8 flex items-center justify-center`} />
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h3>
                    <p className="text-gray-600 text-sm leading-relaxed">{value.desc}</p>
                  </div>
                </FadeIn>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 md:py-20 bg-cream-50">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-7xl mx-auto text-center">
            <FadeIn>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
                Bizi Ziyaret Edin
              </h2>
              <p className="text-gray-600 mb-2 max-w-xl mx-auto text-lg">
                {clinicInfo.address}
              </p>
              <p className="text-gray-500 text-sm mb-8">
                {clinicInfo.workingHours} | {clinicInfo.sunday}
              </p>
              <a
                href={`tel:${clinicInfo.phoneRaw}`}
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-primary-600 hover:bg-primary-700 text-white font-bold rounded-xl transition-all duration-300 whitespace-nowrap shadow-lg hover:shadow-xl hover:-translate-y-0.5"
              >
                <i className="ri-phone-line w-5 h-5 flex items-center justify-center" />
                {clinicInfo.phone}
              </a>
            </FadeIn>
          </div>
        </div>
      </section>
    </main>
  );
}
